import React, { useContext } from 'react';
import { Notification, queue } from '@visionplanner/ui-react-material';

const NotificationContext = React.createContext();

const notificationAction = [{
  icon: {
    icon: 'times',
    basename: 'fal',
    prefix: 'fa-',
    strategy: 'className',
  },
}];

const iconName = {
  success: 'check',
  warning: 'exclamation-triangle',
  info: 'info',
};

const notificationIcon = (type) => ({
  icon: iconName[type],
  basename: 'fas',
  prefix: 'fa-',
  strategy: 'className',
});

const showNotification = ({ title, type, showCloseButton = false }) => {
  queue.notify({
    body: title,
    dismissesOnAction: true,
    icon: type ? notificationIcon(type) : '',
    actions: showCloseButton ? notificationAction : [],
  });
};

/**
 * Context provider to show notification accross application
 */
export const NotificationProvider = ({ children }) => (
  <NotificationContext.Provider value={{ showNotification }}>
    <Notification
      messages={queue.messages}
      dataTa="notification"
      timeout={5000}
    />
    {children}
  </NotificationContext.Provider>
);

/**
 * React hook to use the implementation of `showNotification` provided by `NotificationProvider`. By using
 * this hook, you can notifications anywhere you want in the applicaton.
 */
export const useNotifications = () => useContext(NotificationContext);
